import { VStack } from "@chakra-ui/react";
import { HlaAttributePieChart } from "./HlaAttributePieChart";
import {
  HlaColoring,
  HlaColoringType,
} from "../../../../map/models/HlaColoring";
import { HlaScorePieChart } from "./HlaScorePieChart";

export const HlaPieChart = ({ hlaColoring }: { hlaColoring: HlaColoring }) => {
  const renderContent = () => {
    switch (hlaColoring.type) {
      case HlaColoringType.Attribute:
        return (
          <HlaAttributePieChart attributeName={hlaColoring.attributeName} />
        );

      case HlaColoringType.Score:
        return <HlaScorePieChart crashType={hlaColoring.scoreKey} />;
    }
  };

  return <VStack fontSize="sm">{renderContent()}</VStack>;
};
